import client, { clearGetCache, getCached } from './client';

export const authApi = {
  login: (username, password) => client.post('/auth/login', { username, password }),
  me: () => client.get('/auth/me'),
};

const qs = (params) => {
  const p = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => { if (v != null && v !== '') p.set(k, v); });
  return p.toString();
};

export const salesApi = {
  overview: (f) => getCached(`/sales/overview?${qs(f)}`),
  byDate: (f) => getCached(`/sales/by-date?${qs(f)}`),
  clients: (f) => getCached(`/sales/clients?${qs(f)}`),
  clientsGrouped: (f) => getCached(`/sales/clients-grouped?${qs(f)}`),
  primarySecondary: (f) => getCached(`/sales/primary-secondary?${qs(f)}`),
  primarySecondaryList: (f) => getCached(`/sales/primary-secondary-list?${qs(f)}`),
  topClientsDynamics: (f) => getCached(`/sales/top-clients-dynamics?${qs(f)}`),
  skus: (f) => getCached(`/sales/skus?${qs(f)}`),
  skuDeals: (f) => getCached(`/sales/sku-deals?${qs(f)}`),
  cohort: (f) => getCached(`/sales/cohort?${qs(f)}`),
  segments: (f) => getCached(`/sales/segments?${qs(f)}`),
  churned: (f) => getCached(`/sales/churned?${qs(f)}`),
  territories: (f) => getCached(`/sales/territories?${qs(f)}`),
  territoriesMonthly: (f) => getCached(`/sales/territories/monthly?${qs(f)}`),
  /** Таблица + график менеджеров одним запросом (те же параметры, что на десктопе). */
  managersDashboard: (f) =>
    getCached(`/sales/managers-dashboard?${qs({ ...f, top_n: f?.top_n ?? 5 })}`),
  clientDeals: (f) => getCached(`/sales/client-deals?${qs(f)}`),
  clientExpenses: (f) => getCached(`/sales/client-expenses?${qs(f)}`, { ttlMs: 10 * 60 * 1000 }),
  seminars: (f) => getCached(`/sales/seminars?${qs(f)}`),
  /** Аудит строк 1С по менеджеру (territory) за период — только admin */
  managerAudit: (f) => getCached(`/sales/manager-audit?${qs(f)}`),
  /** Распределение клиентов по LTV (корзины) — только admin */
  ltvDistribution: (f) => getCached(`/sales/ltv-distribution?${qs(f)}`),
};

export const marketingApi = {
  overview: (f) => getCached(`/marketing/overview?${qs(f)}`),
  bySource: (f) => getCached(`/marketing/by-source?${qs(f)}`),
  webAnalytics: (f) => getCached(`/marketing/web-analytics?${qs(f)}`),
  syncMetrika: async (f) => {
    const res = await client.post(`/marketing/sync-metrika?${qs(f)}`);
    clearGetCache((key) => key.includes('/marketing/'));
    return res;
  },
  internetShop: () => getCached('/marketing/internet-shop', { ttlMs: 10 * 60 * 1000 }),
  leadsAmo: (f) => getCached(`/marketing/leads-amo?${qs(f)}`, { ttlMs: 10 * 60 * 1000 }),
  instagram: () => getCached('/marketing/instagram', { ttlMs: 10 * 60 * 1000 }),
  socialNetworks: () => getCached('/marketing/social-networks', { ttlMs: 5 * 60 * 1000 }),
  email: () => getCached('/marketing/email', { ttlMs: 10 * 60 * 1000 }),
};

export const educationApi = {
  /** Без долгого кэша — Excel обновляется вручную */
  tabs: () => client.get('/education/tabs'),
  adsTabs: () => client.get('/education/ads-tabs'),
  companyCosts: (f) => client.get(`/education/company-costs?${qs(f)}`),
};

/** Сопоставление AMO ↔ 1С (вкладка АМОИ1С), только чтение */
export const amo1cApi = {
  match: (f) => client.get(`/amo-1c/match?${qs(f)}`),
  refresh: () => client.post('/amo-1c/refresh'),
  clientOrders: (clientId) =>
    client.get(`/amo-1c/client-orders?${qs({ client_id: clientId })}`),
};

export const aiApi = {
  summary: (f) => getCached(`/ai/summary?${qs(f)}`),
  topChanges: (f) => getCached(`/ai/top-changes?${qs(f)}`),
  anomalies: (f) => getCached(`/ai/anomalies?${qs(f)}`),
};

export const conversionsApi = {
  stages: (f) => getCached(`/conversions/stages?${qs(f)}`),
};

export const adminApi = {
  /** FormData: use_server_file ('true'|'false'), опционально file */
  import1c: (formData) => client.post('/admin/import-1c', formData),
  onecDefaults: () => client.get('/admin/onec-defaults'),
  onecRevenueAudit: (f) => client.get(`/admin/1c-revenue-audit?${qs(f)}`),
  backfill1cDates: () => client.post('/admin/backfill-1c-dates'),
  listUsers: () => client.get('/admin/users'),
  listLoginEvents: (params) =>
    client.get('/admin/login-events', { params: params || { limit: 200 } }),
  createUser: (body) => client.post('/admin/users', body),
  deleteUser: (username) => client.delete(`/admin/users/${encodeURIComponent(username)}`),
  setUserPassword: (username, body) =>
    client.patch(`/admin/users/${encodeURIComponent(username)}/password`, body),
};
